<template>
  <div class="bg-login" id="app">
    <mdb-mask
      overlay="whitee-light"
      class="d-flex justify-content-center align-items-center mask-background"
    >
      <mdb-container>
        <mdb-row class="mt-5 pt-5">
          <mdb-col md="5" class="text-center" style="margin-left: 30%; margin-top: 5%;">
            <mdb-card class="card-login">
              <mdb-card-body class="mx-4">
                <div class="text-center">
                  <img
                    alt="Logo MyFrac"
                    src="https://d39vj9j1h6phln.cloudfront.net/apps/myfrac/admin/assets/Myfrac_logo@3x.png"
                    class="Myfrac-logo"
                  />
                  <p></p>
                  <p></p>
                  <p>
                    <span
                      style="font-family: OpenSans-Bold; font-size: 15px; font-weight: 800;"
                    >Portal contratistas</span>
                  </p>
                </div>
                <div class="alert alert-danger alert-dismissible" v-show="showErrorLogin">
                  <h4>
                    <i class="icon fa fa-ban"></i> Error
                  </h4>Usuario o contraseña incorrectos.
                </div>
                <div class="alert alert-danger alert-dismissible" v-show="showErrorLogin2">
                  <h4>
                    <i class="icon fa fa-ban"></i> Error
                  </h4>
                  Este portal es solo para contratistas, si requieres ingresar a MyFrac ingresa a traves de : <a  href="/">Portal inicio </a>.
                </div>
                <form id="loginForm" class="needs-validation" @submit="login">
                  <div class="form-group" style="text-align: initial;">
                    <label
                      for="email"
                      style="font-family: OpenSans-Regular; font-size: 9px; color: #7b7b7b;"
                    >Correo electrónico</label>
                    <input
                      type="text"
                      class="form-control text-input"
                      id="email"
                      required
                      pattern="[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                      placeholder="Correo electrónico"
                      maxlength="64"
                      v-model="email"
                      style="height: 30px; font-size: 12px; width: 100%;"
                    />
                    <div class="invalid-feedback">Por favor ingresa un correo valido.</div>
                  </div>
                  <div class="form-group" style="text-align: initial;">
                    <label
                      for="password"
                      style="font-family: OpenSans-Regular; font-size: 9px; color: #7b7b7b;"
                    >Contraseña</label>
                    <input
                      type="password"
                      class="form-control text-input"
                      id="password"
                      required
                      placeholder="Contraseña"
                      minlength="5"
                      style="height: 30px; font-size: 12px; width: 100%;"
                      v-model="password"
                    />
                    <div class="invalid-feedback">Contraseña incorrecta</div>
                  </div>
                  <p class="font-small blue-text d-flex justify-content-end pb-3">
                    <a :href="resetRoute" class="grey-text ml-1">¿Olvidaste tu contraseña?</a>
                  </p>
                  <div class="text-center mb-3" v-if="!isLoding">
                    <mdb-btn
                      type="submit"
                      class="btn-block z-depth-1a"
                      style=" color: white; border-radius: 7px; background-image: linear-gradient(1deg, #2566ef, #00d5f6);"
                    >Iniciar Sesión</mdb-btn>
                  </div>
                  <div class="text-center mb-3" v-if="isLoding">
                    <mdb-btn
                      type="submit"
                      class="btn-block z-depth-1a"
                      style="border-radius: 7px; background-image: linear-gradient(1deg, #2566ef, #00d5f6);"
                      disabled
                    >
                      <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    Cargando...
                    </mdb-btn>
                  </div>
                </form>
              </mdb-card-body>
            </mdb-card>
          </mdb-col>
        </mdb-row>
      </mdb-container>
    </mdb-mask>
  </div>
</template>

<script>
/* eslint-disable */
import Axios from "axios";
import Servers from "../../server.js";
import { mapGetters, mapActions } from "vuex";
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardBody,
  mdbInput,
  mdbBtn,
  mdbIcon,
  mdbView,
  mdbMask
} from "mdbvue";
export default {
  name: "Login",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardBody,
    mdbInput,
    mdbBtn,
    mdbIcon,
    mdbView,
    mdbMask
  },
  data() {
    return {
      activePage: "Dashboardv2",
      toggle: false,
      email: "",
      password: "",
      resetRoute: Servers.serverWeb + "password/reset.html",
      showErrorLogin: false,
      showErrorLogin2: false,
      whoami: [],
      serverWeb: "/",
      isLoding: false
    };
  },
  methods: {
    ...mapActions(["authenticate","checkSession"]),
    async login(event) {
      event.preventDefault();
      event.target.classList.add("was-validated");
      // let aux = this;
      this.showErrorLogin = false;
      this.isLoding = true;

      try {
        let data = {
          email: this.email,
          password: this.password
        }
        let response = await this.authenticate(data);
         if(response.status == 200){
              response = await this.checkSession();
              if(response.status==200){
                 if (response.role == "Contratista") {
        window.location.href = "/constructions_contractor";
         this.isLoding = false;
      } else {
        this.showErrorLogin2 = true;
        this.isLoding = false;
      }
        }
      }
        
      } catch (error) {
          console.log(error.response.data);
          this.showErrorLogin = true;
          this.isLoding = false;
      }
    },

    
  }
};
</script>

<style scoped>
.Myfrac-logo {
  width: 250px;
  height: auto;
  margin-top: 15px;
  object-fit: contain;
}
body,
html {
  height: 100%;
}
.card-login {
  border-radius: 8px;
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.08);
  background-color: #ffffff;
}
.bg-login {
  background-image: url("https://d39vj9j1h6phln.cloudfront.net/apps/myfrac/admin/assets/Playstore_Myfrac@3x.png");
  max-height: 1500px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  padding-bottom: 20rem;
  display: block;
}
.form-elegant-login-contractor .font-small {
  font-size: 0.8rem;
}

.form-elegant-login-contractor .z-depth-1a {
  -webkit-box-shadow: 0 2px 5px 0 rgba(55, 161, 255, 0.26),
    0 4px 12px 0 rgba(121, 155, 254, 0.25);
  box-shadow: 0 2px 5px 0 rgba(55, 161, 255, 0.26),
    0 4px 12px 0 rgba(121, 155, 254, 0.25);
}

.form-elegant-login-contractor .z-depth-1-half,
.form-elegant-login-contractor .btn:hover {
  -webkit-box-shadow: 0 5px 11px 0 rgba(85, 182, 255, 0.28),
    0 4px 15px 0 rgba(36, 133, 255, 0.15);
  box-shadow: 0 5px 11px 0 rgba(85, 182, 255, 0.28),
    0 4px 15px 0 rgba(36, 133, 255, 0.15);
}
</style>